import DLL from '@visma/formula/lib/dll';
import React, { useContext } from 'react';
import { AccessTokenContext } from '../context/AccessTokenContext';

const FormulaConfig = ({ formulaUrl, children }) => {

  const accessTokenState = useContext(AccessTokenContext);
  const { accessToken } = accessTokenState;

  return (
    <DLL.FormulaProvider
      axios={(axios) => {
        axios.defaults.baseURL = formulaUrl + '/api';
        if (accessToken) {
          axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
        } else {
          delete axios.defaults.headers.common.Authorization;
        }
      }}
    >
      {children}
    </DLL.FormulaProvider>
  );
}

export default FormulaConfig;
